import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Box,
} from "@material-ui/core";
import { ExpandMore, Help, HelpOutlineOutlined } from "@material-ui/icons";
import Match from "../matching/matching.component";
import useStyles from "./styles";
import { ForecastingPage } from "../forecasting-page/forecasting-page.component";
import GraphsPage from "../graphs-page/graphs-page.component";
import { REACT_APP_VERSION } from "../../configs";
import bestMatches from "../../assets/bestM.webm";
import dataComparison from "../../assets/dataComparison.webm";
import smpGuide from "../../assets/SMP-guide.pdf";
import forecasting from "../../assets/forecasting.webm";

import { useQuery } from "@apollo/client";
import {
  GET_LATEST_STOCKPILES,
  GET_PREPROCESSOR_START,
} from "../../queries/stockpiles.gql";

export const MainPage = (): JSX.Element => {
  const classes = useStyles();
  const [matchesOpened, setMatchesOpened] = useState(true);
  const [showFeedback, setShowFeedback] = useState(false);
  const {
    loading,
    error,
    data: getLatestStockpiles,
  } = useQuery(GET_LATEST_STOCKPILES);

  const { data: getPreprocessorDate } = useQuery(GET_PREPROCESSOR_START);

  const handleFeedbackClick = () => {
    setShowFeedback((value) => !value);
  };

  return (
    <div className="main-page-container">
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        style={{ width: "100%" }}
      >
        <Box
          onClick={() => {
            window.open(smpGuide);
          }}
          style={{ color: "rgba(1,84,176,0.55)", cursor: "pointer" }}
        >
          <Help fontSize={"large"} color="inherit" />
        </Box>
      </Box>
      <Accordion
        className={classes.root}
        expanded={matchesOpened}
        onChange={() => {
          setMatchesOpened((val) => !val);
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore style={{ fill: "white" }} />}
          aria-controls="best-matches-content"
          id="best-matches-header"
          className={classes.summary}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            style={{ width: "100%" }}
          >
            <div>
              <h6 className="text title">
                Best Matches{" "}
                {loading
                  ? "(loading the most recent stockpile...)"
                  : `(most recent stockpile is ${getLatestStockpiles?.getLatestStockpiles[0]?.Stockpile})`}
                {error && "(error)"}
              </h6>
            </div>
            <div>
              <Box onClick={(event) => event.stopPropagation()}>
                <HelpOutlineOutlined onClick={() => window.open(bestMatches)} />
              </Box>
            </div>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <div className="main-page">
            <Match />
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion className={classes.root}>
        <AccordionSummary
          expandIcon={<ExpandMore style={{ fill: "white" }} />}
          aria-controls="data-comparison-content"
          id="data-comparison-header"
          className={classes.summary}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            style={{ width: "100%" }}
          >
            <div>
              <h6 className="text title">Analyze Data and Trends</h6>
            </div>
            <div>
              <Box onClick={(event) => event.stopPropagation()}>
                <HelpOutlineOutlined
                  onClick={() => window.open(dataComparison)}
                />
              </Box>
            </div>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <div className="main-page">
            <GraphsPage />
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion className={classes.root}>
        <AccordionSummary
          expandIcon={<ExpandMore style={{ fill: "white" }} />}
          aria-controls="targets-content"
          id="targets-header"
          className={classes.summary}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            style={{ width: "100%" }}
          >
            <div>
              <h6 className="text title">Forecast Targets</h6>
            </div>
            <div>
              <Box onClick={() => window.open(forecasting)}>
                <HelpOutlineOutlined />
              </Box>
            </div>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <div className="forecasting-page">
            <ForecastingPage />
          </div>
        </AccordionDetails>
      </Accordion>
      <Grid container justifyContent="space-between">
        <Grid item>v. {REACT_APP_VERSION}</Grid>
        <Grid item>
          {/* <Button
            variant="outlined"
            color="primary"
            size="medium"
            onClick={handleFeedbackClick}
          >
            <FeedbackOutlined />
            <span className="ml-1r">Leave feedback</span>
          </Button> */}
        </Grid>
      </Grid>
      {/* {showFeedback && (
        <ModalWindow show={showFeedback}>
          <EndUserFeedback handleFeedbackClick={handleFeedbackClick} />
        </ModalWindow>
      )} */}
    </div>
  );
};
